import {
  FETCH_CONDITIONS,
  UPDATE_CONDITION,
  CREATE_CONDITION,
  DELETE_CONDITION
} from '../../store/constants/hwk';

export function fetchConditions() {
  return {
    type: FETCH_CONDITIONS,
  };
}

export function updateCondition(payload = {}) {
  return {
    type: UPDATE_CONDITION,
    payload,
  };
}

export function createCondition(payload = {}) {
  return {
    type: CREATE_CONDITION,
    payload,
  };
}

export function deleteCondition(id = null) {
  return {
    type: DELETE_CONDITION,
    id,
  };
}
